import { Replay } from "@mui/icons-material";
import { Button, CircularProgress } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { ButtonContainer } from "./Profile.sc";

interface LoadMoreButtonProps {
    isLoadingMore: boolean;
    onLoadMore: () => void;
}

const LoadMoreButton: React.FunctionComponent<LoadMoreButtonProps> = ({ isLoadingMore, onLoadMore }) => {
    const { t } = useTranslation();
    return (
        <ButtonContainer>
            <Button onClick={onLoadMore} startIcon={isLoadingMore ? <CircularProgress style={{ width: 20, height: 20 }} /> : <Replay />}>
                {t("load_more")}
            </Button>
        </ButtonContainer>
    );
};

export default LoadMoreButton;
